import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import ForbiddenPage from "../components/ForbiddenPage";
import { hasMenuPermission } from "../helpers/menuPermissions";

const Route = ({ component: Component, isPrivate = false, requiredPermission = null, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: rest.location?.state?.from?.pathname || "/", state: { from: rest.location } }} />
			</>
		);
	}

	// Gate só na rota que casou. Sem isso, cada <Route> irmã (todas montadas)
	// mostraria 403 ou redirecionaria mesmo fora da URL atual.
	// ForbiddenPage no lugar de Redirect: "/" é o alvo antigo e entra em loop.
	if (!Component) {
		return (
			<>
				{loading && <BackdropLoading />}
				<RouterRoute {...rest} />
			</>
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute
				{...rest}
				render={props =>
					isPrivate &&
					requiredPermission &&
					!loading &&
					!hasMenuPermission(user, requiredPermission) ? (
						<ForbiddenPage />
					) : (
						<Component {...props} />
					)
				}
			/>
		</>
	);
};

export default Route;
